var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-page-content" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.showCreateForm
        ? _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("Yeni Toplu Arama Oluştur"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "batch-call-form" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { icon: "arrow_back" },
                    on: {
                      click: function ($event) {
                        _vm.showCreateForm = false
                      },
                    },
                  },
                  [_vm._v("\n                Listeye Geri Dön\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "batch-call-cost-info" },
                  [
                    _c("a-icon", { attrs: { type: "info-circle" } }),
                    _vm._v(
                      "\n                Batch call cost $0.005 per dial\n            "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form",
                  {
                    attrs: { form: _vm.form, layout: "vertical" },
                    on: { submit: _vm.handleSubmit },
                  },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "Batch Call Adı" } },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "name",
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Lütfen bir kampanya adı girin!",
                                    },
                                  ],
                                },
                              ],
                              expression:
                                "[\n                            'name',\n                            {\n                                rules: [{ required: true, message: 'Lütfen bir kampanya adı girin!' }]\n                            }\n                        ]",
                            },
                          ],
                          attrs: { placeholder: "Kampanya adı girin" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: "Arayan Numara" } },
                      [
                        _c(
                          "a-select",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "fromNumber",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: "Lütfen bir numara seçin!",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n                            'fromNumber',\n                            {\n                                rules: [{ required: true, message: 'Lütfen bir numara seçin!' }]\n                            }\n                        ]",
                              },
                            ],
                            attrs: { placeholder: "Numara seçin" },
                          },
                          _vm._l(_vm.phoneNumbers, function (number) {
                            return _c(
                              "a-select-option",
                              {
                                key: number.phone_number,
                                attrs: { value: number.phone_number },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      number.nickname
                                        ? number.nickname +
                                            " (" +
                                            number.phone_number +
                                            ")"
                                        : number.phone_number
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a-form-item", { attrs: { label: "Alıcılar" } }, [
                      _c(
                        "div",
                        { staticClass: "upload-container" },
                        [
                          _c(
                            "div",
                            { staticClass: "upload-actions" },
                            [
                              _c(
                                "a-upload",
                                {
                                  attrs: {
                                    customRequest: _vm.handleFileUpload,
                                    showUploadList: false,
                                    beforeUpload: _vm.beforeUpload,
                                    accept: ".csv",
                                  },
                                },
                                [
                                  _c("SupsisButton", [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("upload"),
                                    ]),
                                    _vm._v(
                                      " CSV Dosyası Yükle\n                                "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  attrs: { type: "link" },
                                  on: { click: _vm.downloadTemplate },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("download"),
                                  ]),
                                  _vm._v(
                                    " Şablonu İndir\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.csvError
                            ? _c("a-alert", {
                                attrs: {
                                  type: "error",
                                  message: _vm.csvError,
                                  banner: "",
                                  closable: "",
                                },
                                on: {
                                  close: function ($event) {
                                    _vm.csvError = ""
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.csvData.length > 0
                            ? _c("div", { staticClass: "csv-info" }, [
                                _c(
                                  "div",
                                  { staticClass: "csv-file-info" },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("description"),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.fileName) +
                                        "\n                                "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.csvData.length) +
                                          " kişi)"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { type: "link", size: "small" },
                                        on: { click: _vm.handleClearCsv },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: "Ne zaman aransın?" } },
                      [
                        _c(
                          "a-radio-group",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "callSchedule",
                                  {
                                    initialValue: "now",
                                  },
                                ],
                                expression:
                                  "[\n                            'callSchedule',\n                            {\n                                initialValue: 'now'\n                            }\n                        ]",
                              },
                            ],
                            on: { change: _vm.handleScheduleChange },
                          },
                          [
                            _c("a-radio", { attrs: { value: "now" } }, [
                              _vm._v("Şimdi Ara"),
                            ]),
                            _vm._v(" "),
                            _c("a-radio", { attrs: { value: "schedule" } }, [
                              _vm._v("Planla"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isScheduled
                      ? _c(
                          "div",
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "Arama Zamanı" } },
                              [
                                _c("a-date-picker", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "scheduleDate",
                                        {
                                          rules: [
                                            {
                                              required: _vm.isScheduled,
                                              message:
                                                "Lütfen bir tarih seçin!",
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "[\n                                'scheduleDate',\n                                {\n                                    rules: [{ required: isScheduled, message: 'Lütfen bir tarih seçin!' }]\n                                }\n                            ]",
                                    },
                                  ],
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    showTime: { format: "HH:mm" },
                                    format: "YYYY-MM-DD HH:mm",
                                    placeholder: "Tarih ve saat seçin",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-form-item",
                              { attrs: { label: "Zaman Dilimi" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: [
                                          "timezone",
                                          {
                                            initialValue: "Europe/Istanbul",
                                            rules: [
                                              {
                                                required: _vm.isScheduled,
                                                message:
                                                  "Lütfen bir zaman dilimi seçin!",
                                              },
                                            ],
                                          },
                                        ],
                                        expression:
                                          "[\n                                'timezone',\n                                {\n                                    initialValue: 'Europe/Istanbul',\n                                    rules: [{ required: isScheduled, message: 'Lütfen bir zaman dilimi seçin!' }]\n                                }\n                            ]",
                                      },
                                    ],
                                    attrs: {
                                      placeholder: "Zaman dilimi seçin",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "Europe/Istanbul" } },
                                      [_vm._v("İstanbul (GMT+3)")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "Europe/London" } },
                                      [_vm._v("Londra (GMT+0/+1)")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "America/New_York" } },
                                      [_vm._v("New York (GMT-5/-4)")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "Asia/Tokyo" } },
                                      [_vm._v("Tokyo (GMT+9)")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("a-form-item", [
                      _c(
                        "div",
                        { staticClass: "form-actions" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.submitting,
                                disabled: !_vm.canSubmit,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [
                              _vm._v(
                                "\n                            Toplu Aramayı Başlat\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showCreateForm = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            İptal\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "section" }, [
            _c(
              "div",
              { staticClass: "table-wrapper" },
              [
                _c("div", { staticClass: "toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c("a-input-search", {
                        staticClass: "search-input",
                        staticStyle: {
                          width: "300px",
                          margin: "unset !important",
                        },
                        attrs: { placeholder: "Ara" },
                        on: { input: _vm.onSearch },
                        model: {
                          value: _vm.searchText,
                          callback: function ($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.create"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: { primary: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showCreateForm = true
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(
                                "\n                            Yeni Toplu Arama\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-spin",
                  { attrs: { spinning: _vm.loading } },
                  [
                    _c("SupsisTable", {
                      attrs: {
                        columns: _vm.tableColumns,
                        rows: _vm.paginatedBatchCalls,
                        "top-pagination": true,
                        "empty-data-bordered": "",
                        "bottom-pagination": false,
                        "pagination-cursor": _vm.pagination,
                        options: {
                          rowStyleOption: _vm.rowStyleOption,
                          clipboardOption: _vm.clipboardOption,
                          fixedHeader: true,
                          id: "batch-calls-table",
                          borderX: true,
                          borderY: true,
                        },
                      },
                      on: {
                        "cursor-changed": function (cursor) {
                          return (_vm.pagination = cursor)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
      _vm._v(" "),
      _c(
        "a-drawer",
        {
          attrs: {
            title: "Alıcılar",
            placement: "right",
            visible: _vm.showRecipients,
            width: 600,
          },
          on: {
            close: function ($event) {
              _vm.showRecipients = false
            },
          },
        },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.recipientColumns,
              dataSource: _vm.csvData,
              pagination: { pageSize: 10 },
            },
            scopedSlots: _vm._u([
              {
                key: "index",
                fn: function (text, record, index) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(index + 1) +
                        "\n            "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-section" }, [
      _c("div", { staticClass: "title-wrapper" }, [
        _c("h1", { staticClass: "main-title" }, [_vm._v("Toplu Arama")]),
        _vm._v(" "),
        _c("p", { staticClass: "title-description" }, [
          _vm._v(
            "Bu sayfada ses ajanları için toplu arama kampanyalarını\n                yönetebilirsiniz"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }